import _defineProperty from "/codebuild/output/src3618121175/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
// Style as confirm component
import { unit } from '@ant-design/cssinjs';
import { prepareComponentToken, prepareToken } from '.';
import { clearFix } from '../../style';
import { genSubStyleComponent } from '../../theme/internal';
// ============================= Confirm ==============================
var genModalConfirmStyle = function genModalConfirmStyle(token) {
  var componentCls = token.componentCls,
    titleFontSize = token.titleFontSize,
    titleLineHeight = token.titleLineHeight,
    modalConfirmIconSize = token.modalConfirmIconSize,
    fontSize = token.fontSize,
    lineHeight = token.lineHeight,
    modalTitleHeight = token.modalTitleHeight,
    fontHeight = token.fontHeight,
    confirmBodyPadding = token.confirmBodyPadding;
  var confirmComponentCls = "".concat(componentCls, "-confirm");
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, confirmComponentCls, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    '&-rtl': {
      direction: 'rtl'
    }
  }, "".concat(token.antCls, "-modal-header"), {
    display: 'none'
  }), "".concat(confirmComponentCls, "-body-wrapper"), Object.assign({}, clearFix())), "&".concat(componentCls, " ").concat(componentCls, "-body"), {
    padding: confirmBodyPadding
  }), "".concat(confirmComponentCls, "-body"), _defineProperty(_defineProperty({
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'start'
  }, "> ".concat(token.iconCls), {
    flex: 'none',
    fontSize: modalConfirmIconSize,
    marginInlineEnd: token.confirmIconMarginInlineEnd,
    marginTop: token.calc(token.calc(fontHeight).sub(modalConfirmIconSize).equal()).div(2).equal()
  }), "&-has-title > ".concat(token.iconCls), {
    marginTop: token.calc(token.calc(modalTitleHeight).sub(modalConfirmIconSize).equal()).div(2).equal()
  })), "".concat(confirmComponentCls, "-paragraph"), {
    display: 'flex',
    flexDirection: 'column',
    flex: 'auto',
    rowGap: token.marginXS
  }), "".concat(token.iconCls, " + ").concat(confirmComponentCls, "-paragraph"), {
    maxWidth: "calc(100% - ".concat(unit(token.calc(token.modalConfirmIconSize).add(token.marginSM).equal()), ")")
  }), "".concat(confirmComponentCls, "-title"), {
    color: token.colorTextHeading,
    fontWeight: token.fontWeightStrong,
    fontSize: titleFontSize,
    lineHeight: titleLineHeight
  }), "".concat(confirmComponentCls, "-content"), {
    color: token.colorText,
    fontSize: fontSize,
    lineHeight: lineHeight
  }), "".concat(confirmComponentCls, "-btns"), _defineProperty({
    textAlign: 'end',
    marginTop: token.confirmBtnsMarginTop
  }, "".concat(token.antCls, "-btn + ").concat(token.antCls, "-btn"), {
    marginBottom: 0,
    marginInlineStart: token.marginXS
  }))), "".concat(confirmComponentCls, "-error ").concat(confirmComponentCls, "-body > ").concat(token.iconCls), {
    color: token.colorError
  }), "".concat(confirmComponentCls, "-warning ").concat(confirmComponentCls, "-body > ").concat(token.iconCls, ",\n        ").concat(confirmComponentCls, "-confirm ").concat(confirmComponentCls, "-body > ").concat(token.iconCls), {
    color: token.colorWarning
  }), "".concat(confirmComponentCls, "-info ").concat(confirmComponentCls, "-body > ").concat(token.iconCls), {
    color: token.colorInfo
  }), "".concat(confirmComponentCls, "-success ").concat(confirmComponentCls, "-body > ").concat(token.iconCls), {
    color: token.colorSuccess
  });
};
// ============================== Export ==============================
export default genSubStyleComponent(['Modal', 'confirm'], function (token) {
  var modalToken = prepareToken(token);
  return [genModalConfirmStyle(modalToken)];
}, prepareComponentToken, {
  // confirm is weak than modal since no conflict here
  order: -1000
});